// extracted by mini-css-extract-plugin
module.exports = {"title":"view-privacy_title__3-HI-","header":"view-privacy_header__-Zpo6","blurb":"view-privacy_blurb__24MuN","link":"view-privacy_link__1GeAL"};